import { useMutation } from "@tanstack/react-query";
import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:4001";

export interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  message: string;
}

export function useContactSubmit() {
  return useMutation({
    mutationFn: async (data: ContactFormData) => {
      const response = await axios.post(`${API_URL}/api/contacts`, data);
      return response.data;
    },
  });
}
